import moment from "moment";
import React, { useState } from "react";
import { Row, Col, Button, Form, Card, ButtonGroup, Alert, ProgressBar } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";

import DateTimePicker from "react-datetime-picker";
import Utils from "./../../common/Utils";
import LeaveCalendar from "./LeaveCalendar";

const ApplyLeave = (props) => {
  const [apply, setApply] = useState({
    mode: false,
    applying: false,
    paid: 1,
    full: 1,
    hours: 0,
    fromDt: moment().toDate(),
    toDt: moment().toDate(),
  });
  const [lc, setLC] = useState(false);

  const applyingLeave = (e) => {
    var frm = e.currentTarget;
    e.preventDefault();

    /*if(apply.toDt===null){
        window.alert("Please select Leave Upto date!");
        return;
    }*/

    if (apply.full && moment(apply.fromDt).isAfter(moment(apply.toDt))) {
      window.alert("Please select dates correctly, TO date cannot be earlier than FROM date.");
      return;
    }

    const pvals = {
      paid: apply.paid,
      full: apply.full,
      fromDt: moment(apply.fromDt).format("YYYY-MM-DD"),
      reason: frm.reason.value,
    };

    if(apply.full===0){
      pvals['hours'] = apply.hours;
      pvals['toDt'] = pvals['fromDt'];
    }else{
      pvals['toDt'] = moment(apply.toDt ? apply.toDt : apply.fromDt).format("YYYY-MM-DD");
    }

    setApply({ ...apply, applying: true });
    axios
      .post(Utils.apiUrl("leaves/applyleave"), Utils.postVars(pvals), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          props.onApply();
        } else {
          window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
        }
        setApply({ ...apply, applying: false, mode: false });
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Card border="primary" className="shadow">
        <Card.Body>
          <div
            className="d-flex justify-content-between clickable"
            title="Open/close Apply box"
            onClick={() => setApply({ ...apply, mode: !apply.mode })}
          >
            <div className="flex-start">
              <b>Apply for Holiday</b>
            </div>
            <div className="flex-end bg-none">
              {apply.mode === false && <b>+</b>}
              {apply.mode === true && <b>-</b>}
            </div>
          </div>

          {apply.applying === true && (
            <Alert variant="info" className="p-3">
              <p className="loading-msg">Processing your application, please wait..</p>
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}

          {apply.applying === false && apply.mode === true && (
            <div className="py-1">
              <Row>
                <Col sm={2} className="text-center align-middle py-2">
                    <select className="form-select me-1" onChange={(e) => setApply({...apply,full: parseInt(e.currentTarget.value)})}>
                      <option value={1}>Full Day</option>
                      <option value={0}>Partial</option>
                    </select>
                </Col>
                {parseInt(apply.full) === 0 && <>
                  <Col sm={3} className="text-end align-middle py-2">
                    On :  
                    <DateTimePicker
                      minDate={moment().toDate()}
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yyyy"
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => setApply({ ...apply, fromDt: v })}
                      value={apply.fromDt}
                      className="mx-2"
                    />
                  </Col>
                  <Col sm={3} className="text-start align-middle py-2">
                      
                    for : 
                      <select className="form-select mx-2 w-auto d-inline" onChange={(e) => setApply({...apply,hours:e.currentTarget.value})}>
                        {_.map(_.fill(new Array(49),0),(v,idx2) => <option key={idx2} value={(idx2)/4} selected={idx2===0}>{((idx2)/4).toFixed(2)} Hrs.</option>)}
                      </select>
                  </Col>
                  </>}
                {parseInt(apply.full) === 1 && <Col sm={6} className="text-center align-middle py-2">
                  From : &nbsp;
                  <DateTimePicker
                    minDate={moment().toDate()}
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    clearIcon={null}
                    format="y-MM-dd"
                    onChange={(v) => setApply({ ...apply, fromDt: v })}
                    value={apply.fromDt}
                    className="me-2"
                  />
                  To : &nbsp;
                  <DateTimePicker
                    minDate={moment(apply.fromDt).startOf("day").toDate()}
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    clearIcon={null}
                    format="y-MM-dd"
                    onChange={(v) => setApply({ ...apply, toDt: v })}
                    value={!_.isNull(apply.toDt) ? apply.toDt : apply.fromDt}
                  />
                </Col>}
                <Col sm={4} className="text-end align-middle py-2">
                  <div className="d-flex align-items-center" style={{minWidth: "100px"}}>
                    <label className="label-control me-2">Type</label>
                    <select className="form-select me-1" onChange={(e) => setApply({...apply,paid: parseInt(e.currentTarget.value)})}>
                      <option value={1} selected={parseInt(apply.paid)===1}>Paid</option>
                      <option value={0} selected={parseInt(apply.paid)===0}>Unpaid</option>
                    </select>
                    <Button variant="light" className="btn-outline-dark ms-4 py-1 text-nowrap" onClick={() => setLC(!lc)}>
                      View Holiday Calendar
                    </Button>
                  </div>
                </Col>
              </Row>
              <Form onSubmit={applyingLeave}>
                <Row>
                  <Col className="mt-3">
                    <Form.Control as="textarea" name="reason" required={true} placeholder="Reason: " rows={3}></Form.Control>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center mt-3">
                    <Button type="submit" className="px-5">Submit</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          )}
        </Card.Body>
      </Card>
      {lc && <LeaveCalendar fromDt={apply.fromDt} toDt={apply.toDt} onHide={() => setLC(!lc)} />}
    </>
  );
};

export default ApplyLeave;
